import { defineMessages } from "react-intl";

export default defineMessages({
    placeholder: {
        id: "components.mapping.mappingDetailSummary.placeholder",
        defaultMessage: "Select...",
    },
});
